export const nimbleConnectUrlFlag = 'connect';

export const connectRedirectUrls = {
  LOGIN: '/connect/login',
  PREFERENCES: '/connect/preferences',
  PROFILE: '/connect/profile',
  QUALIFICATIONS: '/connect/qualifications',
  RETURN_TO: '/connect',
  SIGN_UP: '/connect/signup',
  MATCH_QUIZ: 'teacherquiz.hirenimble.com/',
  MISSOURI_JOB_DISCOVERY: '/connect/missouri',
  TENNESSEE_JOB_DISCOVERY: '/connect/tennessee',
  RENEW_JOB_SEEKING_STATUS: '/connect/renew-open-to-work',
};

export const connectUrlParams = {
  ACTION: 'action',
  REDIRECT: 'redirect_state',
  SCHOOL: 'school',
  VACANCY: 'vacancy',
  RETURN_TO: 'return_to',
};

export const candidatePortalRoutes = {
  CANDIDATE_PORTAL: '/candidate',
  MATCH_DASHBOARD: '/candidate/matches',
  MATCH_ARCHIVE_DASHBOARD: '/candidate/match-archive',
  PROFILE_DASHBOARD: '/candidate/profile',
};
